import { create } from 'zustand';
import { authService } from '../services/auth';

export const useUserStore = create((set) => ({
  // State
  usageStats: null,
  isLoadingStats: false,

  // Actions
  fetchUsageStats: async () => {
    set({ isLoadingStats: true });
    try {
      const stats = await authService.getUsageStats();
      set({ usageStats: stats, isLoadingStats: false });
      return stats;
    } catch (error) {
      console.error('Failed to fetch usage stats:', error);
      set({ isLoadingStats: false });
      return null;
    }
  },

  clearStats: () => set({ usageStats: null }),
}));
